import { useTranslation } from "react-i18next";
import { Grid, Paper, Typography, Box, Button, Avatar } from "@mui/material";

//import icons
import { Location, CallCalling, Sms, Call, Send2, Instagram } from "iconsax-react";

//import image
import mohammadiImg from "../../../assets/imgs/mohammadi.png";
import alizadehImg from "../../../assets/imgs/Alizadeh.png";

//import style
import "./contact-us-information.scss";

function ContactUsInformation() {
    //general variables
    const { t } = useTranslation();

    // render icons with consistent styling
    const renderIcon = icon => {
        const Icon = icon;
        return (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "var(--teal-color-01)",
                    borderRadius: "50%",
                    width: 40,
                    height: 40,
                }}
            >
                <Icon color="var(--teal-color-18)" variant="Outline" />
            </Box>
        );
    };

    const contactCards = [
        {
            name: t("General.Ms. Mohammadi"),
            title: t("salesExpert"),
            phone: "09961650417",
            avatar: mohammadiImg,
            telegram: "https://t.me/Atripa_ai",
        },
        {
            name: t("General.Ms. Zare"),
            title: t("salesExpert"),
            phone: "09961650399",
            avatar: null,
            telegram: "https://t.me/AtripaSupport",
        },
    ];

    const infoItems = [
        { label: t("email"), value: "contact@atripa.com", icon: Sms, href: "mailto:contact@atripa.com" },
        { label: t("phone"), value: t("phoneNumber1"), icon: CallCalling, href: "tel:+985136572582" },
        { label: t("address"), value: t("mashhadAddress"), icon: Location },
        { label: t(""), value: t("General.Instagram"), icon: Instagram, href: "https://www.instagram.com/atripa.ir?igsh=MW1ub2lmNTE1ZGN0cA==" },
    ];

    return (
        <Grid className="contact-us-information" container item xs={12} rowGap={3} justifyContent="space-between" alignItems="flex-start">
            <Grid container item xs={12} columnSpacing={2} rowSpacing={2}>
                {contactCards.map(card => (
                    <Grid item xs={6} md={6} key={card.phone}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: { xs: 1, md: 2 },
                                borderRadius: 3,
                                bgcolor: " var(--primary-color-10)",
                                width: "100%",
                                direction: "rtl",
                            }}
                        >
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                gap={1}
                                sx={{ flexDirection: { xs: "column", md: "row" } }}
                            >
                                {/* Buttons part*/}
                                <Box
                                    display="flex"
                                    gap={1}
                                    sx={{
                                        order: { xs: 2, md: 1 },
                                        flexDirection: { xs: "column", md: "row" },
                                        width: { xs: "95%", md: "auto" },
                                        mb: { xs: 0.5, md: 0 },
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        endIcon={<Call size="17" style={{ transform: "scaleX(-1)" }} />}
                                        component="a"
                                        href={`tel:${card.phone}`}
                                        sx={{
                                            bgcolor: "var(--primary-color)",
                                            "&:hover": { bgcolor: "var( --teal-color-12)" },
                                            borderRadius: { xs: 3, md: 2 },
                                            gap: 1,
                                            fontSize: { xs: "0.792rem" },
                                        }}
                                    >
                                        {card.phone}
                                    </Button>

                                    <Button
                                        variant="contained"
                                        endIcon={<Send2 size={18} />}
                                        component="a"
                                        href={card.telegram}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                            bgcolor: "var(--blue-color)",
                                            "&:hover": { bgcolor: "var(--secondary-color)" },
                                            borderRadius: { xs: 3, md: 2 },
                                            gap: 1,
                                            fontSize: { xs: "0.75rem", md: "0.875rem" },
                                        }}
                                    >
                                        {t("telegram")}
                                    </Button>
                                </Box>

                                {/*  Profile part*/}
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                    sx={{ order: { xs: 1, md: 2 }, flexDirection: { xs: "column", md: "row" } }}
                                >
                                    <Box textAlign="center" sx={{ order: { xs: 2, md: 1 } }}>
                                        <Typography
                                            variant="subtitle1"
                                            fontWeight="bold"
                                            sx={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            {card.name}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            {card.title}
                                        </Typography>
                                    </Box>

                                    <Avatar src={card.avatar} alt={card.name} sx={{ width: 80, height: 80, order: { xs: 1, md: 2 } }} />
                                </Box>
                            </Box>
                        </Paper>
                    </Grid>
                ))}
            </Grid>

            {/* Info items */}
            <Grid container item xs={12} md={5.9} rowGap={2}>
                {infoItems.map(item => (
                    <Grid container item xs={12} columnGap={2} key={item.label}>
                        <Paper elevation={0} style={{ padding: "10px", backgroundColor: "var(--white-gray-color)", width: "100%" }}>
                            <Grid container alignItems="center" columnGap={2}>
                                {renderIcon(item.icon)}
                                <Grid item container direction="column" xs>
                                    <Typography variant="body1" sx={{ fontSize: { xs: "0.875rem", md: "1rem" } }}>
                                        {item.label}
                                    </Typography>
                                    <Typography variant="body1">
                                        <a className="contact-us-information__link" href={item?.href}>
                                            {item.value}
                                        </a>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                ))}
            </Grid>

            {/* Map Section */}
            <Grid className="contact-us-information__location" container item xs={12} md={6} justifyContent="space-between" alignItems="center">
                <iframe src="https://www.openstreetmap.org/export/embed.html?bbox=59.53915804624558%2C36.3588651892918%2C59.54269856214524%2C36.360714157772996&amp;layer=mapnik&amp;marker=36.359789679023145%2C59.540928304195404" />
                <br />
                <small>
                    <a
                        className="contact-us-information__view-map"
                        href="https://www.openstreetmap.org/?mlat=36.359790&amp;mlon=59.540928#map=19/36.359790/59.540928&amp;layers=N"
                    >
                        View Larger Map
                    </a>
                </small>
            </Grid>
        </Grid>
    );
}

export default ContactUsInformation;
